import * as t from "io-ts";

import { nonprofitAdminReferralCampaignResponseCodec } from "../codecs/entities";
import { HttpMethod } from "../helpers/http";

import { makeRouteSpec } from ".";

export const getReferralCampaignSpec = makeRouteSpec({
  path: "/referralCampaign/:referralCode",
  method: HttpMethod.GET,
  authenticated: false,
  tokensCodec: t.type({ referralCode: t.string }),
  paramsCodec: t.type({}),
  bodyCodec: t.type({}),
  responseBodyCodec: t.union([
    t.null,
    nonprofitAdminReferralCampaignResponseCodec,
  ]),
});
